import React, { useContext } from "react"
import styled from "styled-components"
import AcIcon from "~/components/atoms/AcIcon"
import AcButton from "../atoms/AcButton"
import { ParticipantsContext } from "~/components/twilio/ParticipantsProvider"

const Toggle = styled.div`
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  display: flex;
  align-items: center;
  .loading {
    animation: spin 700ms infinite linear;
  }
  p {
    margin-left: 8px;
    font-size: 11px;
    color: #6b6bf9;
  }
`
const Button = styled(AcButton)`
  background-color: #6b6bf9;
  color: #ffffff;
  border-radius: 3px;
  padding: 0 10px;
  i {
    font-size: 20px;
  }
`

export default function ToggleRecordButton(props: {
  disabled?: boolean
  className?: string
  onClick: () => void
  loading: boolean
}) {
  const { isRecording } = useContext(ParticipantsContext)

  const displayIcon = () => {
    let iconName: string

    if (props.loading) {
      iconName = "spinner"
    } else {
      iconName = isRecording ? "pause" : "play"
    }

    return iconName
  }

  return (
    <Toggle>
      <Button onClick={props.onClick}>
        <AcIcon name={displayIcon()} />
      </Button>
      <p className="desc">{isRecording ? "録画一時停止" : "録画再開"}</p>
    </Toggle>
  )
}
